export const TAG = 'tag'

export const getInitialValues = ({ editProductTagData }) => ({
  [TAG]: editProductTagData?.title || ''
})
